import * as Html from "../../util/Html.ts";
import { checkInput, isDomEmpty, markValidNative, markInvalidNative, type ValidationFunction } from "../../util/forms.ts";
import * as i18n from "../../i18n.ts";
import ApiServer from "../../ApiServer.ts";

export {initDom}
Html.registerWidget('widget/form/validator',{initDom})

var
  VALIDATOR_ATTRIBUTE = "data-fw-form-validator",

  EMAIL_REGEX = /^[\-a-z0-9~!$%\^&*_=+}{\'?]+(\.[\-a-z0-9~!$%\^&*_=+}{\'?]*)*@([a-z0-9_][\-a-z0-9_]*(\.[\-a-z0-9_]+)*\.([a-z]{2,})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i,

  validator : Record<string,(this:HTMLInputElement,... params : string[])=>boolean> = {
    email(this :HTMLInputElement){
      var
        value = this.value = this.value.trim();
      if(!EMAIL_REGEX.test(value)){
        throw new Error(i18n.get("errors.emailInvalid"));
      }
      return true;
    },
    emailidentifier(this :HTMLInputElement){
      var
        value = this.value = this.value.trim(),
        input = this,
        isSubmitRunning = (input.form.getAttribute('data-submit-running')==='true');

      //check its a mail
      if(!EMAIL_REGEX.test(value)){
        throw new Error(i18n.get("errors.emailInvalid"));
      }
      //if it has just been verified it's ok
      if(value===input.getAttribute('data-valid-value')){
        return true;
      }
      //check it is a free identifier
      ApiServer.log2check(null,value,function(isAvailable){
        if (!isAvailable){
          markInvalidNative(input, i18n.get("errors.emailUnavaible"));
        }else{
          markValidNative(input);
          //store valid value
          input.setAttribute('data-valid-value',value);
          //we interuppted submit by this validation, so we resubmit
          if(isSubmitRunning){
            input.form.requestSubmit()
          }
        }
      },function(error){
        markInvalidNative(input, i18n.get("invitationJs.errorEmail") );
      });
      //invalid while it is not checked
      return false;
    },
    loginidentifier(this :HTMLInputElement){
      var
        value = this.value = this.value.trim();
      if(value.indexOf('@')>-1){
        throw new Error(i18n.get("errors.identifierInvalid"));
      }
      return true;
    },
    identifier(this: HTMLInputElement){
      const value = this.value = this.value.trim();
      if(isDomEmpty(this)){
        throw new Error(this.getAttribute("data-fw-form-required-error")||i18n.get("fw2.fields.requiredError",this.getAttribute("placeholder")));
      }
      return true;
    },
    password(this: HTMLInputElement){
      const value = this.value = this.value.trim();
      if(value.length<8){
        throw new Error(i18n.get("errors.passwordTooShort"))
      }
      return true;
    },
    passwordConfirm(this :HTMLInputElement, passName :string){
      var
        value = this.value = this.value.trim();
      if(value === this.form[passName].value){
        return true;
      }else{
        throw new Error(i18n.get("formUserPasswordChange.errorConfirm"))
      }
    },
    required(this: HTMLInputElement){
      return !isDomEmpty(this)
    },
    requiredifempty(this: HTMLInputElement, otherfield: string){
      if(!isDomEmpty(this)){
        return true;
      }
      for(let i=0; i<arguments.length; i++){
        if(!isDomEmpty(this.form[arguments[i]] as HTMLInputElement)){
          return true;
        }
      }
      return false;
    }

  };

function initDom(input: HTMLInputElement){
  if(input.getAttribute(VALIDATOR_ATTRIBUTE)){
    const validatorAttr = input.getAttribute(VALIDATOR_ATTRIBUTE);
    const validatorCall = validatorAttr.split(':');
    const validatorFunc = validator[validatorCall[0]];
    const validatorArgs = validatorCall.splice(1);

    checkInput(
      input,
      function(inputEl: HTMLElement){
        return validatorFunc.apply(inputEl as HTMLInputElement, validatorArgs);
      },
      i18n.get(input.getAttribute("data-fw-form-validator-error")||"")
    );
  }else{
    console.log('input validator without validator', input)
  }
}
